export var RecipientFilter;
(function (RecipientFilter) {
    RecipientFilter["Company"] = "company";
    RecipientFilter["Tranche"] = "tranche";
    RecipientFilter["Specific"] = "specific";
    RecipientFilter["Subscriptions"] = "subscriptions";
    RecipientFilter["NoSubscriptions"] = "noSubscriptions";
    RecipientFilter["All"] = "all";
    RecipientFilter["SubscriptionCustomTags"] = "subscriptionCustomTags";
    RecipientFilter["InvestorCustomTags"] = "investorCustomTags";
})(RecipientFilter || (RecipientFilter = {}));
export var Status;
(function (Status) {
    Status["Draft"] = "DRAFT";
    Status["Submitted"] = "SUBMITTED";
})(Status || (Status = {}));
//# sourceMappingURL=api.js.map